export default "__VITE_PUBLIC_ASSET__5e10d699__"